<template>
    <div>service {{rmsobject}}</div>
</template>

<script>
    export default {
        name: "rms-objects-service-tab",
        props: ['user', 'rmsobject'],
        mounted() {
            this.init();
        },
        methods: {
            init: function(){}
        }
    }
</script>

<style scoped>

</style>